<input class="uk-checkbox toggle-all" type="checkbox" (change)="toggleAllCheckboxes($event)" />
